import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    const normalized =
      error instanceof Error
        ? error
        : new Error(error != null ? String(error) : "An unexpected error occurred");
    return { hasError: true, error: normalized };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);

    const isChunkError =
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("dynamically imported module");

    if (isChunkError && !sessionStorage.getItem("chunk_reload_attempted")) {
      sessionStorage.setItem("chunk_reload_attempted", "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      const isChunkError =
        this.state.error?.name === "ChunkLoadError" ||
        this.state.error?.message?.includes("Loading chunk") ||
        this.state.error?.message?.includes("dynamically imported module");

      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
          fontFamily: "sans-serif",
          color: "#333",
          textAlign: "center",
        }}>
          <h2 style={{ marginBottom: 12 }}>
            {isChunkError ? "Page failed to load" : "Something went wrong"}
          </h2>
          <p style={{ color: "#666", marginBottom: 24, maxWidth: 400 }}>
            {isChunkError
              ? "A page resource could not be loaded. This may be a temporary network issue."
              : "An unexpected error occurred. Please reload and try again."}
          </p>
          <div style={{ display: "flex", gap: 12 }}>
            <button
              onClick={() => { sessionStorage.removeItem("chunk_reload_attempted"); window.location.reload(); }}
              style={{ padding: "8px 20px", background: "#60A8DC", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer", fontSize: 14 }}
            >
              Reload page
            </button>
            <button
              onClick={() => { window.location.href = "/"; }}
              style={{ padding: "8px 20px", background: "#f0f0f0", color: "#333", border: "none", borderRadius: 4, cursor: "pointer", fontSize: 14 }}
            >
              Go to home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
